import React, { useState, useEffect, useCallback } from "react";
import Modal from "react-modal";
import Select from "react-select";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import LoadingIcon from "mdi-react/LoadingIcon";
import DataTable from "react-data-table-component";
import { withRouter, useLocation } from "react-router";
import { marked } from "marked";

import {
  reelsConstants,
  eventsConstants,
  menuUrlConstants,
  QUESTION_TYPE_IDS,
  eventsStatusConstants,
  configurationsConstants,
  eventsSortingOptions,
  string,
} from "../../constants";
import {
  customToast,
  getFilterExpression,
  formatDateByTimezone,
  formatTimeByTimezone,
} from "../../shared";
import PaginationComponent from "../../shared/components/PaginationComponent/PaginationComponent";
import {
  eventsActions,
  messageBoardActions,
  configurationsActions,
} from "../../redux/actions";
import ViewEventDetail from "./ViewEventDetail";
import MessageBoardModal from "./Modal/MessageBoardModal";
import InvoiceModal from "./Modal/InvoiceModal";

const {
  GET_EVENTS,
  CANCEL_EVENT,
  REASSIGN_SHUTTERBS,
  VIEW_EVENT_SHUTTERBS,
  UPCOMING_EVENTS_DEFAULT_ORDER_BY_EXPRESSION,
  COMPLETED_EVENTS_DEFAULT_ORDER_BY_EXPRESSION,
  CANCELLED_EVENTS_DEFAULT_ORDER_BY_EXPRESSION,
} = eventsConstants;

const filterOptions = [
  {
    Name: "Id",
    Selector: "Id",
  },
  {
    Name: "EventName",
    Selector: "EventName",
  },
  {
    Name: "EventDate",
    Selector: "EventDate",
  },
  {
    Name: "ShutterbNames",
    Selector: "ShutterbNames",
  },
  {
    Name: "EventHost",
    Selector: "EventHost",
  },
  {
    Name: "EventHostEmail",
    Selector: "EventHostEmail",
  },
  {
    Name: "Province",
    Selector: "StateOrProvince",
  },
];

const Events = (props) => {
  const { t } = useTranslation("common");

  const location = useLocation();
  const [date, setDate] = useState();
  const [timezone, setTimezone] = useState("");
  const [eventId, setEventId] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [expandedCard, setExpandedCard] = useState(null);
  const [currentEvent, setCurrentEvent] = useState(null);
  const [isViewDetail, setIsViewDetail] = useState(false);
  const [expandedSubCard, setExpandedSubCard] = useState(null);
  const [filterOptionValue, setFilterOptionValue] = useState("");
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [isAccessGroupGallery, setIsAccessGroupGallery] = useState(false);
  const [isEventDetailModalOpen, setIsEventDetailModalOpen] = useState(false);
  const [pagination, setPagination] = useState({
    pageSize: configurationsConstants.DEFAULT_PAGINATION_PAGE_SIZE,
    pageNumber: 1,
    totalRows: 0,
  });
  const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);
  const [selectedEventGroupId, setSelectedEventGroupId] = useState(null);
  const [orderByExpression, setOrderByExpression] = useState(string.EMPTY);
  const [selectedSortOption, setSelectedSortOption] = useState(string.EMPTY);

  const token = sessionStorage.getItem("payload");
  const encodedToken = encodeURIComponent(token);
  const url = `/event_booking?token=${encodedToken}`;

  const spinner = useCallback(
    (type) => props.spinnerActions.findIndex((f) => f === type),
    [props.spinnerActions]
  );

  const handleCollapseToggle = (cardId) => {
    setExpandedCard(cardId === expandedCard ? null : cardId);
  };

  const handleSubCollapseToggle = (cardId) => {
    setExpandedSubCard(cardId === expandedSubCard ? null : cardId);
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  useEffect(() => {
    // Check if the hash in the URL is "#sharedGallery"
    if (location.hash !== "#sharedGallery") {
      setIsViewDetail(false);
      setIsAccessGroupGallery(false);
    }
  }, [location.hash]);

  const handleViewDetail = (id) => {
    setCurrentEvent(id);
    setIsViewDetail(true);
  };

  const handleCloseViewDetail = () => {
    setIsViewDetail(false);
    setIsAccessGroupGallery(false);
  };

  const handleCancelEvent = (
    eventGroupId,
    pageSize,
    pageNumber,
    filterExpression,
    id
  ) => {
    if (window.confirm("Are you sure ? "))
      props.cancelEvent(
        eventGroupId,
        pageSize,
        pageNumber,
        filterExpression,
        id
      );
  };

  const handleMessageBoard = (eventId) => {
    setCurrentEvent(eventId);
    setIsMessageModalOpen(true);
  };

  const handleInvoice = (eventGroupId) => {
    setSelectedEventGroupId(eventGroupId);
    setIsInvoiceModalOpen(true);
  };

  const columns = [
    {
      width: "100%",
      cell: (row) => {
        return (
          <React.Fragment key={row.eventGroupId}>
            <div className="card card-style pagination-card-width mb-2">
              <div className="card-header back-color">
                <p className="mb-0">
                  <a
                    href={`#${row.eventGroupId}`}
                    className="collapsed d-flex justify-content-between a-style"
                    onClick={() => handleCollapseToggle(row.eventGroupId)}
                  >
                    <div className="p-0 m-0">
                      {row?.isGroup
                        ? (row?.eventGroupName ??
                          eventsConstants.EVENT_GROUP_NAME_NOT_AVAILABLE)
                        : (row?.subEvents[0]?.eventName ??
                          eventsConstants.EVENT_NAME_NOT_AVAILABLE)}
                      {row.isGroup &&
                        ` - ${row?.subEvents?.length || 0} events`}
                      {!row.isGroup
                        ? ` - ${formatDateByTimezone(
                            row?.subEvents[0]?.eventDate,
                            row?.subEvents[0]?.timezone
                          )}`
                        : ""}
                    </div>
                    <strong>
                      {row.isGroup
                        ? `${t("group_Id")} ${row.eventGroupId}`
                        : `${t("event_Id")} ${row.subEvents[0].id}`}
                    </strong>
                  </a>
                </p>
              </div>
              <div
                id={`collapse${row.eventGroupId}`}
                className={`collapse ${
                  expandedCard === row.eventGroupId ? "show" : ""
                }`}
              >
                <div className="card-body">
                  {row?.isGroup && (
                    <div>
                      <button
                        type="submit"
                        className="btn btn-info"
                        onClick={() => {
                          setIsAccessGroupGallery(true);
                          handleViewDetail(row.eventGroupId);
                          window.location.hash = "sharedGallery";
                        }}
                      >
                        {t("view_gallery")}
                      </button>
                      <button
                        disabled={!row?.isGroupReelExist}
                        type="submit"
                        className="btn btn-info"
                        onClick={() => {
                          props.setIsReelDetailModalOpen();
                          props.setReelDetailModalEventGroupId(
                            row.eventGroupId
                          );
                        }}
                      >
                        View All Recap Details
                      </button>
                      <button
                        disabled={
                          !location.pathname.includes(
                            menuUrlConstants.UPCOMING_EVENTS_TAB
                          ) || !row.isCancelAllEventAllowed
                        }
                        type="submit"
                        className="btn btn-info"
                        onClick={() =>
                          handleCancelEvent(
                            row.eventGroupId,
                            pagination.pageSize,
                            pagination.pageNumber,
                            getFilterExpression(searchText)
                          )
                        }
                      >
                        {t("cancel_all_event")}
                      </button>
                    </div>
                  )}
                  {row?.subEvents && row?.subEvents?.length > 1 ? (
                    row?.subEvents.map((item, index) => {
                      return (
                        <div className="card card-style pagination-card-width mb-2 w-100">
                          <div className="card-header back-color">
                            <p className="mb-0">
                              <a
                                href={`#${item.id}`}
                                className="collapsed d-flex justify-content-between a-style"
                                onClick={() => handleSubCollapseToggle(item.id)}
                              >
                                <div className="p-0 m-0">
                                  {`${++index} - `}
                                  {item?.eventName ??
                                    eventsConstants.EVENT_NAME_NOT_AVAILABLE}
                                  {` - ${formatDateByTimezone(
                                    item.eventDate,
                                    item.timezone
                                  )}`}
                                </div>
                                <strong>
                                  {" "}
                                  {`${t("event_Id")} ${item.id}`}
                                </strong>
                              </a>
                            </p>
                          </div>
                          <div
                            id={`collapse${item.id}`}
                            className={`collapse ${
                              expandedSubCard === item.id ? "show" : ""
                            }`}
                          >
                            <div className="card-body">
                              {[
                                {
                                  label: t("event_host"),
                                  value: item.eventHost,
                                },
                                {
                                  label: t("event_host_email"),
                                  value: item.eventHostEmail,
                                },
                                {
                                  label: t("event_date"),
                                  value: formatDateByTimezone(
                                    item.eventDate,
                                    item.timezone
                                  ),
                                },
                                {
                                  label: t("event_start_time"),
                                  value: formatTimeByTimezone(
                                    item.eventStartTime,
                                    item.timezone
                                  ),
                                },
                                {
                                  label: t("event_location"),
                                  value: item.currentLocation,
                                },
                                {
                                  label: t("duration"),
                                  value: item.duration,
                                },
                                {
                                  label: t("sb_start_time"),
                                  value: formatTimeByTimezone(
                                    item.sbStartTime,
                                    item.timezone
                                  ),
                                },
                                {
                                  label: t("event_type"),
                                  value: item.eventTypeName,
                                },
                                {
                                  label: t("appartment"),
                                  value: item.apartment,
                                },
                                {
                                  label: t("additional_notes"),
                                  value: item.additionalNotes,
                                },
                                item.contactName &&
                                  item.contactName !== "" && {
                                    label: t("contact_name"),
                                    value: item.contactName,
                                  },
                                item.phoneNumber &&
                                  item.phoneNumber !== "" && {
                                    label: t("contact_number"),
                                    value: item.phoneNumber,
                                  },
                                {
                                  label: t("total_gallery_views"),
                                  value: item.totalGalleryViews,
                                },
                                {
                                  label: t("consent_for_marketing"),
                                  value: item.isConsentForMarketing
                                    ? "True"
                                    : "False",
                                },
                                {
                                  label: t("gallery_shared_permission"),
                                  value: item.isGallerySharedPermission
                                    ? "True"
                                    : "False",
                                },
                                {
                                  label: t("Assignee"),
                                  value: item.shutterbNames,
                                },
                              ]
                                .filter(Boolean)
                                .map(({ label, value }) => (
                                  <div className="d-flex" key={label}>
                                    <p className="text-left w-25 fw-bold">
                                      {label}
                                    </p>
                                    <p className="w-75">{value}</p>
                                  </div>
                                ))}
                              <button
                                disabled={
                                  !item.isActive ||
                                  !location.pathname.includes(
                                    menuUrlConstants.UPCOMING_EVENTS_TAB
                                  )
                                }
                                type="submit"
                                className="btn btn-info"
                                onClick={() =>
                                  handleCancelEvent(
                                    item.eventGroupId,
                                    pagination.pageSize,
                                    pagination.pageNumber,
                                    getFilterExpression(searchText),
                                    item.id
                                  )
                                }
                              >
                                {t("cancel_event")}
                              </button>
                              <button
                                disabled={!item.isActive}
                                type="submit"
                                className="btn btn-info"
                                onClick={() => {
                                  openModal();
                                  props.viewEventShutterbs(item.id);
                                  setEventId(item.id);
                                }}
                              >
                                {t("Reassign shutterb")}
                              </button>
                              <button
                                type="submit"
                                className="btn btn-info"
                                onClick={() => {
                                  props.getEventDetailByEventId(item.id);
                                  setIsEventDetailModalOpen(true);
                                  setEventId(item.id);
                                }}
                              >
                                shot list
                              </button>
                              <button
                                disabled={!item.isActive}
                                type="submit"
                                className="btn btn-info"
                                onClick={() => {
                                  handleViewDetail(item.id);
                                  window.location.hash = "sharedGallery";
                                }}
                              >
                                {t("view_gallery")}
                              </button>
                              {item.isReelExist === 1 && (
                                <button
                                  disabled={!item.isActive}
                                  type="submit"
                                  className="btn btn-info"
                                  onClick={() => {
                                    props.setIsReelDetailModalOpen();
                                    props.setReelDetailModalEventId(item.id);
                                  }}
                                >
                                  {t("View Recap Details")}
                                </button>
                              )}
                              <button
                                type="submit"
                                className="btn btn-info"
                                onClick={() => {
                                  handleMessageBoard(item.id);
                                }}
                              >
                                {t("see_messages")}
                              </button>
                              <button
                                type="submit"
                                className="btn btn-info"
                                onClick={() => {
                                  handleInvoice(item.eventGroupId);
                                }}
                              >
                                {t("download_invoice")}
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : row?.subEvents && row?.subEvents?.length === 1 ? (
                    row?.subEvents.map((item, index) => {
                      return (
                        <>
                          {[
                            { label: t("event_host"), value: item.eventHost },
                            {
                              label: t("event_host_email"),
                              value: item.eventHostEmail,
                            },
                            {
                              label: t("event_date"),
                              value: formatDateByTimezone(
                                item.eventDate,
                                item.timezone
                              ),
                            },
                            {
                              label: t("event_start_time"),
                              value: formatTimeByTimezone(
                                item.eventStartTime,
                                item.timezone
                              ),
                            },
                            {
                              label: t("event_location"),
                              value: item.currentLocation,
                            },
                            {
                              label: t("duration"),
                              value: item.duration,
                            },
                            {
                              label: t("sb_start_time"),
                              value: formatTimeByTimezone(
                                item.sbStartTime,
                                item.timezone
                              ),
                            },
                            {
                              label: t("event_type"),
                              value: item.eventTypeName,
                            },
                            {
                              label: t("appartment"),
                              value: item.apartment,
                            },
                            {
                              label: t("additional_notes"),
                              value: item.additionalNotes,
                            },
                            item.contactName &&
                              item.contactName !== "" && {
                                label: t("contact_name"),
                                value: item.contactName,
                              },
                            item.phoneNumber &&
                              item.phoneNumber !== "" && {
                                label: t("contact_number"),
                                value: item.phoneNumber,
                              },
                            {
                              label: t("total_gallery_views"),
                              value: item.totalGalleryViews,
                            },
                            {
                              label: t("consent_for_marketing"),
                              value: item.isConsentForMarketing
                                ? "True"
                                : "False",
                            },
                            {
                              label: t("gallery_shared_permission"),
                              value: item.isGallerySharedPermission
                                ? "True"
                                : "False",
                            },
                            {
                              label: t("Assignee"),
                              value: item.shutterbNames,
                            },
                          ]
                            .filter(Boolean)
                            .map(({ label, value }) => (
                              <div className="d-flex" key={label}>
                                <p className="text-left w-25 fw-bold">
                                  {label}
                                </p>
                                <p className="w-75">{value}</p>
                              </div>
                            ))}
                          <button
                            disabled={
                              !item.isActive ||
                              !location.pathname.includes(
                                menuUrlConstants.UPCOMING_EVENTS_TAB
                              )
                            }
                            type="submit"
                            className="btn btn-info"
                            onClick={() =>
                              handleCancelEvent(
                                item.eventGroupId,
                                pagination.pageSize,
                                pagination.pageNumber,
                                getFilterExpression(searchText),
                                item.id
                              )
                            }
                          >
                            {t("cancel_event")}
                          </button>
                          <button
                            disabled={!item.isActive}
                            type="submit"
                            className="btn btn-info"
                            onClick={() => {
                              openModal();
                              props.viewEventShutterbs(item.id);
                              setEventId(item.id);
                            }}
                          >
                            {t("Reassign shutterb")}
                          </button>
                          <button
                            type="submit"
                            className="btn btn-info"
                            onClick={() => {
                              props.getEventDetailByEventId(item.id);
                              setIsEventDetailModalOpen(true);
                              setEventId(item.id);
                            }}
                          >
                            shot list
                          </button>
                          <button
                            disabled={!item.isActive}
                            type="submit"
                            className="btn btn-info"
                            onClick={() => {
                              handleViewDetail(item.id);
                              window.location.hash = "sharedGallery";
                            }}
                          >
                            {t("view_gallery")}
                          </button>
                          {item.isReelExist === 1 && (
                            <button
                              disabled={!item.isActive}
                              type="submit"
                              className="btn btn-info"
                              onClick={() => {
                                props.setIsReelDetailModalOpen();
                                props.setReelDetailModalEventId(item.id);
                              }}
                            >
                              {t("View Recap Details")}
                            </button>
                          )}
                          <button
                            type="submit"
                            className="btn btn-info"
                            onClick={() => {
                              handleMessageBoard(item.id);
                            }}
                          >
                            {t("see_messages")}
                          </button>
                          <button
                            type="submit"
                            className="btn btn-info"
                            onClick={() => {
                              handleInvoice(item.eventGroupId);
                            }}
                          >
                            {t("download_invoice")}
                          </button>
                        </>
                      );
                    })
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      },
      allowOverflow: true,
      button: true,
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
      },
    },
    rows: {
      style: {
        "&:not(:last-of-type)": {
          borderBottomWidth: "0px",
        },
      },
    },
  };

  useEffect(() => {
    if (location.pathname.includes(menuUrlConstants.COMPLETED_EVENTS_TAB)) {
      setOrderByExpression(COMPLETED_EVENTS_DEFAULT_ORDER_BY_EXPRESSION);
      props.getCompletedEvents(
        pagination.pageSize,
        pagination.pageNumber,
        getFilterExpression(searchText),
        COMPLETED_EVENTS_DEFAULT_ORDER_BY_EXPRESSION
      );
    } else if (
      location.pathname.includes(menuUrlConstants.UPCOMING_EVENTS_TAB)
    ) {
      setOrderByExpression(UPCOMING_EVENTS_DEFAULT_ORDER_BY_EXPRESSION);
      props.getUpcomingEvents(
        pagination.pageSize,
        pagination.pageNumber,
        getFilterExpression(searchText),
        UPCOMING_EVENTS_DEFAULT_ORDER_BY_EXPRESSION
      );
    } else if (
      location.pathname.includes(menuUrlConstants.CANCELED_EVENTS_TAB)
    ) {
      setOrderByExpression(CANCELLED_EVENTS_DEFAULT_ORDER_BY_EXPRESSION);
      props.getCanceledEvents(
        pagination.pageSize,
        pagination.pageNumber,
        getFilterExpression(searchText),
        CANCELLED_EVENTS_DEFAULT_ORDER_BY_EXPRESSION
      );
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setPagination({
      pageSize: props.data.pageSize,
      pageNumber: props.data.currentPage,
      totalRows: props.data.total,
    });
  }, [props.data]);

  const userOptions = props.allShutterbs?.map((user) => ({
    value: user.id,
    label: `${user.firstName} ${user.lastName} - ${user.email}`,
  }));

  const handleUserSelection = (selectedOptions, index) => {
    setSelectedUsers((prevSelectedUsers) => {
      const updatedSelectedUsers = [...prevSelectedUsers];
      updatedSelectedUsers[index] = selectedOptions;
      return updatedSelectedUsers;
    });
  };

  useEffect(() => {
    const defaultSelectedShutterb = props.eventShutterbs.flatMap(
      (shutterb) => ({
        value: shutterb.oldSBUserId,
        label: `${shutterb.sbName} - ${shutterb.email}`,
      })
    );
    setSelectedUsers(defaultSelectedShutterb);
    // eslint-disable-next-line
  }, [props.eventShutterbs]);

  const handleAssignShutterB = () => {
    const dataToSend = props.eventShutterbs.map((shutterb, index) => {
      const selectedUser = selectedUsers[index];

      return {
        orderItemId: shutterb.orderItemId,
        oldSBUserId: shutterb.oldSBUserId,
        newSBUserId: selectedUser ? selectedUser.value : shutterb.newSBUserId,
        status: "created",
      };
    });

    const filteredDataToSend = dataToSend.filter(
      (item) => item.oldSBUserId !== item.newSBUserId
    );
    if (filteredDataToSend.length > 0) {
      props.resAssignShutterbs(
        eventId,
        { reassignSb: filteredDataToSend },
        pagination.pageSize,
        pagination.pageNumber,
        getFilterExpression(searchText),
        closeModal
      );
    } else {
      closeModal();
    }
  };

  useEffect(() => {
    if (selectedSortOption !== string.EMPTY) {
      setOrderByExpression(selectedSortOption);
    }
  }, [selectedSortOption]);

  const handlePaginationGetData = (size, page, filter) => {
    debugger;
    location.pathname.includes(menuUrlConstants.COMPLETED_EVENTS_TAB)
      ? props.getCompletedEvents(size, page, filter, orderByExpression)
      : location.pathname.includes(menuUrlConstants.UPCOMING_EVENTS_TAB)
        ? props.getUpcomingEvents(size, page, filter, orderByExpression)
        : props.getCanceledEvents(size, page, filter, orderByExpression);
  };

  return (
    <div className="row mr-0">
      <div className="col-md-12">
        <div className="col-lg-12">
          <div className="tab-content">
            {isViewDetail ? (
              <ViewEventDetail
                currentEvent={currentEvent}
                onClose={handleCloseViewDetail}
                isAccessGroupGallery={isAccessGroupGallery}
              />
            ) : (
              <div className="tab-pane fade show active">
                <button
                  type="button"
                  className="btn btn-info mb-0"
                  onClick={() => {
                    window.location.href = `${process.env.REACT_APP_HOST_URL}${url}`;
                  }}
                >
                  {t("Book now")}
                </button>
                {spinner(GET_EVENTS) && spinner(CANCEL_EVENT) ? (
                  <div>
                    <PaginationComponent
                      pagination={pagination}
                      setPagination={setPagination}
                      searchText={searchText}
                      setSearchText={setSearchText}
                      getTableData={handlePaginationGetData}
                      filterOptionValue={filterOptionValue}
                      setFilterOptionValue={setFilterOptionValue}
                      filterOptions={filterOptions}
                      isFilterKeyValuePair={true}
                      isDateIncluded
                      date={date}
                      setDate={setDate}
                      timezone={timezone}
                      setTimezone={setTimezone}
                      enableSorting={true}
                      sortingOptions={eventsSortingOptions}
                      setSelectedSortOption={setSelectedSortOption}
                      selectedSortOption={selectedSortOption}
                    />
                    <DataTable
                      columns={columns}
                      data={props.data.items}
                      responsive
                      customStyles={customStyles}
                      className="no-scroll"
                    />
                  </div>
                ) : (
                  <div className="text-center mt-4">
                    <LoadingIcon className="loading-spinner" />
                  </div>
                )}
                <Modal
                  isOpen={modalIsOpen}
                  onRequestClose={closeModal}
                  contentLabel="Set Shutterbs Modal"
                  className="image-modal"
                  style={{
                    content: {
                      width: "auto",
                      height: "auto",
                      margin: "auto",
                    },
                  }}
                >
                  <div className="modal-content">
                    <h3 className="d-flex justify-content-center">
                      {t("Reassign shutterbs")}
                    </h3>
                    {spinner(VIEW_EVENT_SHUTTERBS) &&
                    spinner(REASSIGN_SHUTTERBS) ? (
                      <>
                        <table className="table">
                          <thead>
                            <tr>
                              <th scope="col">Price</th>
                              <th scope="col">Status</th>
                              <th scope="col">Assignee</th>
                            </tr>
                          </thead>
                          <tbody>
                            {props.eventShutterbs &&
                              props.eventShutterbs?.map((orderItem, index) => (
                                <tr key={index}>
                                  <td className="pt-custom">
                                    ${orderItem.price}
                                  </td>
                                  <td className="pt-custom">
                                    {orderItem.status ===
                                    eventsStatusConstants.CREATED
                                      ? eventsStatusConstants.PENDING
                                      : orderItem.presenceStatus ===
                                          eventsStatusConstants.CHECKOUT
                                        ? orderItem.presenceStatus
                                        : orderItem.status}
                                  </td>
                                  <td>
                                    <Select
                                      options={userOptions}
                                      value={
                                        selectedUsers &&
                                        selectedUsers.length > 0
                                          ? selectedUsers[index]
                                          : null
                                      }
                                      isDisabled={
                                        orderItem.presenceStatus ===
                                        eventsStatusConstants.CHECKOUT
                                      }
                                      onChange={(selectedOptions) => {
                                        const selectedValue =
                                          selectedOptions?.value;
                                        const matchingUserIndex =
                                          selectedUsers.findIndex(
                                            (user) =>
                                              user.value === selectedValue
                                          );
                                        if (matchingUserIndex === -1) {
                                          handleUserSelection(
                                            selectedOptions,
                                            index
                                          );
                                        } else if (
                                          matchingUserIndex !== index
                                        ) {
                                          customToast(
                                            t(
                                              "shutterb already assigned for this event"
                                            ),
                                            toast.TYPE.ERROR
                                          );
                                        }
                                      }}
                                    />
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        <button
                          type="submit"
                          className="btn btn-primary w-100"
                          onClick={handleAssignShutterB}
                        >
                          {t("Assign")}
                        </button>
                        <button onClick={closeModal} className="modal-close">
                          <img
                            src="/images/simpleCrossWhite.svg"
                            alt="crossIcon"
                            className="modal-close-img"
                          />
                        </button>
                      </>
                    ) : (
                      <div className="text-center mt-4 h-150">
                        <LoadingIcon className="loading-spinner" />
                      </div>
                    )}
                  </div>
                </Modal>

                <Modal
                  isOpen={isEventDetailModalOpen}
                  onRequestClose={setIsEventDetailModalOpen}
                  contentLabel="shot list"
                  className="reel-detail-con"
                >
                  <div className="main-con">
                    <div className="row w-100">
                      {props.eventDetailById.length <= 0 ? (
                        <h4 className="d-flex justify-content-center align-items-center pl-5">
                          no detail exists ...
                        </h4>
                      ) : (
                        <table>
                          <thead>
                            <tr>
                              <td colSpan="12">shot list</td>
                            </tr>
                            <tr>
                              <td colSpan="12"> {eventId}</td>
                            </tr>
                          </thead>
                          <tbody>
                            <>
                              <tr>
                                <th>{t("event_type")}</th>
                                <td>
                                  {props.eventDetailById?.eventType?.name || ""}
                                </td>
                              </tr>
                              <tr>
                                <th>Event Overview:</th>
                                <td>
                                  {props.eventDetailById?.eventQuestionAnswers?.find(
                                    (f) =>
                                      f.questionTypeId ==
                                      QUESTION_TYPE_IDS.CONTENT_USAGE
                                  )?.answer ?? ""}
                                </td>
                              </tr>
                              <tr>
                                <th>{t("event_shot_list")}</th>
                                <td
                                  className="event-detail-shotlist"
                                  dangerouslySetInnerHTML={{
                                    __html: marked(
                                      props.eventDetailById.eventType
                                        .description || ""
                                    ),
                                  }}
                                />
                              </tr>
                              <tr>
                                <th>{t("brand_and_legal_requirements")}</th>
                                <td>
                                  {props.eventDetailById?.eventQuestionAnswers?.find(
                                    (f) =>
                                      f.questionTypeId ==
                                      QUESTION_TYPE_IDS.BRAND_GUIDELINES
                                  )?.answer ?? ""}
                                </td>
                              </tr>
                            </>
                          </tbody>
                        </table>
                      )}
                    </div>
                    <button
                      onClick={() => setIsEventDetailModalOpen(false)}
                      className="modal-close"
                    >
                      <img
                        src="/images/simpleCrossWhite.svg"
                        alt="crossIcon"
                        className="modal-close-img"
                      />
                    </button>
                  </div>
                </Modal>
              </div>
            )}
          </div>
        </div>
      </div>
      {isMessageModalOpen ? (
        <MessageBoardModal
          isModalOpen={isMessageModalOpen}
          setIsModalOpen={setIsMessageModalOpen}
          className="message-board-modal"
          currentEvent={currentEvent}
        />
      ) : (
        ""
      )}
      <InvoiceModal
        isModalOpen={isInvoiceModalOpen}
        setIsModalOpen={setIsInvoiceModalOpen}
        selectedEventGroupId={selectedEventGroupId}
        setSelectedEventGroupId={setSelectedEventGroupId}
      />
    </div>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  data: state.events.data,
  spinnerActions: state.system.spinnerActions,
  allShutterbs: state.configurations.allShutterbs,
  eventShutterbs: state.events.eventShutterbs,
  eventDetailById: state.events.eventDetailById,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getCompletedEvents: (pageSize, pageNumber, filterExpression, orderBy) =>
    dispatch(
      eventsActions.getCompletedEvents(
        pageSize,
        pageNumber,
        filterExpression,
        orderBy
      )
    ),
  getUpcomingEvents: (pageSize, pageNumber, filterExpression, orderBy) =>
    dispatch(
      eventsActions.getUpcomingEvents(
        pageSize,
        pageNumber,
        filterExpression,
        orderBy
      )
    ),
  getCanceledEvents: (pageSize, pageNumber, filterExpression, orderBy) =>
    dispatch(
      eventsActions.getCanceledEvents(
        pageSize,
        pageNumber,
        filterExpression,
        orderBy
      )
    ),
  cancelEvent: (eventGroupId, pageSize, pageNumber, filterExpression, id) =>
    dispatch(
      eventsActions.cancelEvent(
        eventGroupId,
        pageSize,
        pageNumber,
        filterExpression,
        id
      )
    ),
  getAllShutterBsForReels: () =>
    dispatch(configurationsActions.getAllShutterBsForReels()),
  viewEventShutterbs: (id) => dispatch(eventsActions.viewEventShutterbs(id)),
  resAssignShutterbs: (
    eventId,
    data,
    pageSize,
    pageNumber,
    filterExpression,
    closeModal
  ) =>
    dispatch(
      eventsActions.resAssignShutterbs(
        eventId,
        data,
        pageSize,
        pageNumber,
        filterExpression,
        closeModal
      )
    ),
  setIsReelDetailModalOpen: () =>
    dispatch({
      type: reelsConstants.SET_IS_REEL_DETAIL_MODAL_OPEN,
    }),
  setReelDetailModalEventId: (eventId) =>
    dispatch({
      type: reelsConstants.SET_REEL_DETAIL_MODAL_EVENT_ID,
      data: eventId,
    }),
  setReelDetailModalEventGroupId: (eventGroupId) =>
    dispatch({
      type: reelsConstants.SET_REEL_DETAIL_MODAL_EVENT_GROUP_ID,
      data: eventGroupId,
    }),
  getEventDetailByEventId: (eventId) =>
    dispatch(eventsActions.getEventDetailByEventId(eventId)),
  getshutterbzByEventId: (eventId) =>
    dispatch(messageBoardActions.getshutterbByEventId(eventId)),
});

// Mapping action and store the function via props
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Events));
